import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MdcDialogComponent } from './mdc-dialog.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'confirm-dialog',
  imports: [MdcDialogComponent, MatButtonModule, MatDialogModule],
  template: `
    <mdc-dialog [dialogTitle]="data.title" [closeOnSave]="false" hideClose>
      <ng-template #contentTemplate>
        <div class="body-1 pb-20">
          {{ data.message }}
        </div>
      </ng-template>
      <ng-template #actionsTemplate>
        <button
          matButton="elevated"
          class="charcoal-button w-auto! px-15"
          mat-dialog-close>
          CANCEL
        </button>
        <button
          matButton="elevated"
          class="red-button w-auto! px-15"
          [mat-dialog-close]="data.confirmButton">
          {{ data.confirmButton }}
        </button>
      </ng-template>
    </mdc-dialog>
  `
})
export class ConfirmDialogComponent {
  #dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);
  data: DialogData = inject(MAT_DIALOG_DATA);
}

export interface DialogData {
  title: string;
  message: string;
  confirmButton: string;
}
